import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptStorno: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconReceiptStorno"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.4982L7.26556 20.259L9.66667 22.3171L12 20.3171L14.3333 22.3171L16.7344 20.259L20 22.4982V2H4ZM8 14H16V16H8V14ZM15.1339 7.53033L13.7197 6.11612L12 7.83579L10.2803 6.11612L8.86612 7.53033L10.5858 9.25L8.86612 10.9697L10.2803 12.3839L12 10.6642L13.7197 12.3839L15.1339 10.9697L13.4142 9.25L15.1339 7.53033Z" fill="currentColor"/></CentralIconBase>;
});

export default IconReceiptStorno;
